import React from 'react'

const EmptyStateProviders = (props) => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 283.4 166.7"
      style={{
        enableBackground: 'new 0 0 283.4 166.7'
      }}
      xmlSpace="preserve"
      {...props}
    >
      <style>
        {
          '.st1{fill:var(--primaryColor)}.st4,.st6{fill:#bbb;stroke:#6b6b6b;stroke-width:3.29;stroke-linejoin:round;stroke-miterlimit:10}.st6{fill:#fff}.st7{fill:#e5e5e4}.st9{fill:#6b6b6b}.st10,.st11{fill:none;stroke:#aaa;stroke-width:1.2337;stroke-miterlimit:10}.st11{stroke:#6b6b6b;stroke-width:3.29;stroke-linejoin:round}.st14{fill:#e2e2e2}'
        }
      </style>
      <circle
        cx={213.2}
        cy={94.1}
        r={29.7}
        style={{
          opacity: 0.15,
          fill: '#bfbebe'
        }}
      />
      <path className="st1" d="m239.1 137.1 3.8 4.4 11.7-11.1-4-3.9z" />
      <ellipse
        cx={129.7}
        cy={144.7}
        rx={119.5}
        ry={12.1}
        style={{
          fill: '#bbb'
        }}
      />
      <ellipse
        cx={129.7}
        cy={144.7}
        rx={74.5}
        ry={7.6}
        style={{
          fill: '#939292'
        }}
      />
      <path
        className="st4"
        d="M110.3 55.4c0 2.4 2 4.4 4.4 4.4h75.8c4.3 0 7.8 3.5 7.8 7.8V120c0 13.6-11 24.7-24.7 24.7H74c-11.5 0-18.7-8.4-18.7-18.7V52.4c0-2.4 2-4.4 4.4-4.4H103c4 0 7.3 3.3 7.3 7.4z"
      />
      <path
        transform="rotate(-180 81.961 56.286)"
        style={{
          fill: '#838383'
        }}
        d="M59.9 54.3h44.2v4H59.9z"
      />
      <path
        className="st6"
        d="M87.3 125.7v-35h123.9v33.4c0 11.3-9.2 20.5-20.5 20.5H87.3v-.4"
      />
      <path
        className="st7"
        d="M87.3 126.3s-.4 9.7-2.1 11.3c-1.8 1.6-8.2 5.4-8.2 5.4h116c12.3 0 16.4-16.3 16.4-16.3l-122.1-.4z"
      />
      <path className="st4" d="M71.3 144.5c11 .2 15.6-7.6 16-16.8v-1.9" />
      <path className="st7" d="M209.4 126.7s-.5 12.2-15 16.3" />
      <path
        d="M57.1 128.6h28.5S85.5 143 71.4 143c-12.3 0-14.3-14.4-14.3-14.4z"
        style={{
          fill: '#aaa'
        }}
      />
      <path
        className="st9"
        d="M127.6 6.8c0-.3.3-.6.6-.6h4.1c.3 0 .6.3.6.6s-.3.6-.6.6h-4.1c-.3.1-.6-.2-.6-.6z"
      />
      <path
        className="st9"
        d="M130.3 4.2c.3 0 .6.3.6.6v4.1c0 .3-.3.6-.6.6s-.6-.3-.6-.6V4.8c0-.4.2-.6.6-.6zM216.8 44.3c0-.3.3-.6.6-.6h4.1c.3 0 .6.3.6.6s-.3.6-.6.6h-4.1c-.4 0-.6-.3-.6-.6z"
      />
      <path
        className="st9"
        d="M219.4 41.6c.3 0 .6.3.6.6v4.1c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-4.1c0-.3.3-.6.6-.6z"
      />
      <circle
        transform="rotate(-15.605 107.376 20.074)"
        className="st10"
        cx={107.4}
        cy={20.1}
        r={2.7}
      />
      <path
        className="st9"
        d="M23.5 81.9c-.3 0-.6-.3-.6-.6v-4.1c0-.3.3-.6.6-.6s.6.3.6.6v4.1c0 .4-.3.6-.6.6z"
      />
      <path
        className="st9"
        d="M20.8 79.3c0-.3.3-.6.6-.6h4.1c.3 0 .6.3.6.6s-.3.6-.6.6h-4.1c-.3 0-.6-.3-.6-.6z"
      />
      <circle
        transform="rotate(-15.42 36.683 102.206)"
        className="st10"
        cx={36.7}
        cy={102.2}
        r={2.7}
      />
      <circle
        transform="rotate(-15.605 149.222 46.97)"
        className="st10"
        cx={149.2}
        cy={47}
        r={2.7}
      />
      <path
        className="st1"
        d="M216 19.8c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7zM36.7 71.9c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7-.1 1.5-1.3 2.7-2.7 2.7zM89.9 18.3c-1 0-1.9-.8-1.9-1.9 0-1 .8-1.9 1.9-1.9 1 0 1.9.8 1.9 1.9 0 1.1-.8 1.9-1.9 1.9z"
      />
      <path
        className="st11"
        d="M267.1 157.6c-3.1 2.6-7.7 2.3-10.3-.8l-17.9-20.7 11.1-9.6 17.9 20.7c2.6 3.1 2.3 7.7-.8 10.4z"
      />
      <path className="st6" d="M243.9 141.6 255 132M257.3 157.4l11.1-9.6" />
      <path
        className="st7"
        d="M236.6 128.2s4.6-1.5 6.3-5.1l-1.9-2.2-6.8 4.8 2.4 2.5z"
      />
      <path
        className="st11"
        d="M234.9 120.2c-1.2 1-2.3 2-3.5 2.9l9.2 10.6c.3.3.9.2 1.5-.3l4.9-4.2c.5-.5.8-1.1.5-1.4l-9.2-10.6c-1.1 1-2.3 2-3.4 3z"
      />
      <path
        className="st6"
        d="M187.7 65.7c-15.9 13.7-17.7 37.8-3.9 53.7 13.7 15.9 37.8 17.7 53.7 3.9 15.9-13.7 17.7-37.8 3.9-53.7-13.7-15.9-37.8-17.7-53.7-3.9zm44.7 51.7c-12.7 11-31.9 9.6-42.8-3.1s-9.6-31.9 3.1-42.8c12.7-11 31.9-9.6 42.8 3.1s9.6 31.9-3.1 42.8z"
      />
      <path
        d="M212.8 61.5c-18.2 0-32.9 14.7-32.9 32.9s14.7 32.9 32.9 32.9 32.9-14.7 32.9-32.9-14.7-32.9-32.9-32.9zm0 64c-17.2 0-31.1-13.9-31.1-31.1s13.9-31.1 31.1-31.1c17.2 0 31.1 13.9 31.1 31.1s-13.9 31.1-31.1 31.1z"
        style={{
          fill: '#eaeae9'
        }}
      />
      <path
        d="M213.2 70c8.3 0 15.6 4.2 19.9 10.5"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: 3.29,
          strokeLinecap: 'round',
          strokeMiterlimit: 10
        }}
      />
      <path
        className="st14"
        d="m248 140.2 11.6 13.1-2.2 2-11.4-13.5zM261.8 155.7l-1.8 1.5s3.6 1.5 5.9-.8c0 .1-2.9.5-4.1-.7zM237.9 125l5 5.5-1.7 1.4-4.9-5.6z"
      />
      <path
        style={{
          fill: 'var(--primaryColor)'
        }}
        d="m247.8 130.6 2.9 3 1.8-1.7-2.7-3.1z"
      />
    </svg>
  )
}

export default EmptyStateProviders



// WEBPACK FOOTER //
// ./src/assets/images/svg/empty-state-providers.js